import { gql } from '@apollo/client'
import { MUTATION_STATE, UPDATE_CREATION_FREQUENCY_FIELDS } from '../fragments'

const PAYLOAD = 'UpdateCreationFrequencyPayload'

export const UPDATE_CREATION_FREQUENCY = gql`
    ${UPDATE_CREATION_FREQUENCY_FIELDS}
    ${MUTATION_STATE(PAYLOAD)}
    mutation updateCreationFrequency($creationId: ID!, $frequency: Int) {
        updateCreationFrequency(input: { creationId: $creationId, frequency: $frequency }) {
            ...UpdateCreationFrequencyFields
            ...MutationState${PAYLOAD}Fields
        }
    }
`
